module.exports = __webpack_public_path__ + "static/media/scroll.558d3d17.mp3";